import { List } from "antd";
import { useEffect, useMemo, useState } from "react";
import { SpeedItemData } from "../types/types";
import StatusLabel from "./StatusLabel";

interface IHTTPSpeedItem {
  item: SpeedItemData;
}
const HTTPSpeedItem = (props: IHTTPSpeedItem) => {
  const { item } = props;
  const [speed, setSpeed] = useState(NaN);
  const [reason, setReason] = useState("-");
  const [hasError, setHasError] = useState(false);
  useEffect(() => {
    if (item.url) {
      const start = Date.now();
      fetch(item.url)
        .then((res) => {
          if (res.status === 200) {
            setReason(`${res.status}`);
            res.json().finally(() => {
              setSpeed(Date.now() - start);
            });
          } else {
            setHasError(true);
            setReason(`${res.status}`);
          }
        })
        .catch(() => {
          setHasError(true);
        })
        .finally(() => {
          setSpeed(Date.now() - start);
        });
    }
  }, [item]);
  const itemStatus = useMemo(() => {
    const isError = hasError || speed > 2000;
    const isWarning = !hasError && speed < 2000 && speed > 1000;
    const isNormal = !hasError && speed < 1000;
    return isError ? "🔴" : isWarning ? "🟠" : isNormal ? "🟢" : "⚪";
  }, [hasError, speed]);

  return (
    <List.Item>
      <List.Item.Meta avatar={itemStatus} title={item.name} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <StatusLabel type={hasError ? "danger" : "success"} content={reason} />
        <StatusLabel
          type={
            speed > 2000 ? "danger" : speed > 1000 ? "warning" : "secondary"
          }
          content={`${speed}ms`}
        />
      </div>
    </List.Item>
  );
};

export default HTTPSpeedItem;
